/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface V1TypedObjectReference
 */
export interface V1TypedObjectReference {
    /**
     * APIGroup is the group for the resource being referenced.
     * If APIGroup is not specified, the specified Kind must be in the core API group.
     * For any other third-party types, APIGroup is required.
     * +optional
     * @type {string}
     * @memberof V1TypedObjectReference
     */
    apiGroup?: string;
    /**
     * Kind is the type of resource being referenced
     * @type {string}
     * @memberof V1TypedObjectReference
     */
    kind?: string;
    /**
     * Name is the name of resource being referenced
     * @type {string}
     * @memberof V1TypedObjectReference
     */
    name?: string;
    /**
     * Namespace is the namespace of resource being referenced
     * Note that when a namespace is specified, a gateway.networking.k8s.io/ReferenceGrant object is required in the referent namespace to allow that namespace's owner to accept the reference. See the ReferenceGrant documentation for details.
     * (Alpha) This field requires the CrossNamespaceVolumeDataSource feature gate to be enabled.
     * +featureGate=CrossNamespaceVolumeDataSource
     * +optional
     * @type {string}
     * @memberof V1TypedObjectReference
     */
    namespace?: string;
}

export function V1TypedObjectReferenceFromJSON(json: any): V1TypedObjectReference {
    return V1TypedObjectReferenceFromJSONTyped(json, false);
}

export function V1TypedObjectReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1TypedObjectReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apiGroup': !exists(json, 'apiGroup') ? undefined : json['apiGroup'],
        'kind': !exists(json, 'kind') ? undefined : json['kind'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'namespace': !exists(json, 'namespace') ? undefined : json['namespace'],
    };
}

export function V1TypedObjectReferenceToJSON(value?: V1TypedObjectReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'apiGroup': value.apiGroup,
        'kind': value.kind,
        'name': value.name,
        'namespace': value.namespace,
    };
}

